/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("FrontCallService.modules.browser", ["FrontCallService"], function (context, cls) {
  /**
   * Browser module of Frontcall Service
   * @instance browser
   * @memberOf gbc.FrontCallService.modules
   */
  context.FrontCallService.modules.browser = /** @lends gbc.FrontCallService.modules.browser */ {
    /**
     * Gets the current URL
     */
    getApplicationState: async function () {
      if (gbc.__wrapper.isPlatformTypeBrowser()) {
        // need to check first that current app is a main app
        if (gbc.SessionService.getCurrent().getCurrentApplication().getProcIdParent()) {
          // not main app as there is a parent
          this.runtimeError("Can only getApplicationState from main application");
        } else {
          // execute frontcall as we are in the main app
          const textResult = globalThis.location.hash;
          this.setReturnValues([textResult.substring(1)]);
        }
      } else {
        this.runtimeError("Not available on this platform");
      }
    },

    /**
     * Set the current URL anchor
     * @param {String} hashtag
     */
    setApplicationState: async function (hashtag) {
      if (hashtag?.includes("#")) {
        this.runtimeError("Anchor cannot contain #");
        return;
      }
      // Valid identifier: starts with letter or _, followed by letters/digits/_
      if (!/^[A-Za-z_]\w*$/.test(hashtag)) {
        this.runtimeError("Anchor is not a valid identifier");
        return;
      }
      if (gbc.__wrapper.isPlatformTypeBrowser()) {
        // need to check first that current app is a main app
        if (gbc.SessionService.getCurrent().getCurrentApplication().getProcIdParent()) {
          // not main app as there is a parent
          this.runtimeError("Can only setApplicationState from main application");
        } else {
          // execute frontcall as we are in the main app
          const url = new URL(globalThis.location.href);
          url.hash = hashtag ? `#${hashtag}` : "";
          history.replaceState({}, "", url.toString());
          this.setReturnValues([]);
        }
      } else {
        this.runtimeError("Not available on this platform");
      }
    }
  };
});
